import latestNewsIcon from "../assets/svgs/latest-news.svg";
export const dashboardJson = {
  customerData: [
    { heading: 186, subheading: "Overdue Policies" },
    { heading: 55, subheading: "Expired Policies" },
    { heading: 80, subheading: "Renewed Policies" },
  ],
  locationComparisonData: [
    { uv: 18, name: "Burlington, Vermont" },
    { uv: 21, name: "Hartford, Connecticut" },
    { uv: 29, name: "Boston, Massachusetts" },
  ],
  stackedBarChartData: [
    { name: "Week 1", Open: 2, "In Progress": 3, Closed: 4 },
    { name: "Week 2", Open: 2, "In Progress": 5, Closed: 6 },
    { name: "Week 3", Open: 3, "In Progress": 6, Closed: 7 },
    { name: "Week 4", Open: 4, "In Progress": 11, Closed: 4 },
  ],
  existingBusinessData: [
    { heading: "112", subheading: "Total Policies Sold" },
    { heading: "$133,275.00", subheading: "Total Premium Written" },
    { heading: "$98,350.50", subheading: "Total Claims Raised" },
    { heading: "$19,991.25", subheading: "Total Commission Earned" },
    { heading: "0.95", subheading: "Retention Ratio", percentage: false },
    { heading: "0.74", subheading: "Loss Ratio", percentage: false },
  ],
  policiesData: [
    {
      number: "100",
      description: "Auto Insurance",
      image: "policy",
    },
    {
      number: "80",
      description: "Homeowners Insurance",
      image: "policy",
    },
    {
      number: "50",
      description: "Renters Insurance",
      image: "policy",
    },
  ],
  latestNewsData: [
    {
      description:
        "We're excited to announce the launch of our new mobile app, Insure Ease. Now you can manage your policies, file claims, and access your insurance cards right from your smartphone. Download it today from your app store for a more convenient insurance experience.",
      date: "10th Oct",
      time: "04:30 pm",
      image: latestNewsIcon,
      name: "ACME Insurance",
    },
    {
      description:
        "Hurricane season is approaching. As part of our commitment to your safety, we're offering free home inspections to all our homeowners insurance policyholders in coastal areas. Schedule yours before August 15th to ensure your property is prepared for severe weather.",
      date: "10th Oct",
      time: "05:30 pm",
      image: latestNewsIcon,
      name: "ACME Insurance",
    },
  ],
  newBusinessData: [
    { heading: 186, subheading: "New Quotes" },
    { heading: 55, subheading: "In Progress" },
    { heading: 80, subheading: "Issued" },
    { heading: "3:1", subheading: "Conversion Ratio" },
  ],
  premiumWrittenData: [
    { name: "Week 1", uv: 8000 },
    { name: "Week 2", uv: 11000 },
    { name: "Week 3", uv: 14000 },
    { name: "Week 4", uv: 16000 },
  ],
  policiesSoldData: [
    { name: "Week 1", uv: 18 },
    { name: "Week 2", uv: 22 },
    { name: "Week 3", uv: 28 },
    { name: "Week 4", uv: 32 },
  ],
  lobCompaniesData: [
    { name: "Umbrella Insurance", uv: 800 },
    { name: "Renters Insurance", uv: 1100 },
    { name: "Auto Insurance", uv: 1400 },
    { name: "Homeowners Insurance", uv: 1600 },
  ],
  comissionTrackingData: [
    { day: "01st Jul", value: 3000 },
    { day: "02nd Jul", value: 3000 },
    { day: "03rd Jul", value: 3500 },
    { day: "04th Jul", value: 3500 },
    { day: "05th Jul", value: 4000 },
    { day: "06th Jul", value: 4500 },
    { day: "07th Jul", value: 5000 },
    { day: "08th Jul", value: 5500 },
    { day: "09th Jul", value: 5500 },
    { day: "10th Jul", value: 6000 },
    { day: "11th Jul", value: 7000 },
    { day: "12th Jul", value: 7500 },
    { day: "13th Jul", value: 8000 },
    { day: "14th Jul", value: 8000 },
    { day: "15th Jul", value: 9000 },
    { day: "16th Jul", value: 9500 },
    { day: "17th Jul", value: 10000 },
    { day: "18th Jul", value: 10500 },
    { day: "19th Jul", value: 10500 },
    { day: "20th Jul", value: 11000 },
    { day: "21st Jul", value: 11000 },
    { day: "22nd Jul", value: 11000 },
    { day: "23rd Jul", value: 11500 },
    { day: "24th Jul", value: 12000 },
    { day: "25th Jul", value: 12000 },
    { day: "26th Jul", value: 12000 },
    { day: "27th Jul", value: 12500 },
    { day: "28th Jul", value: 12500 },
    { day: "29th Jul", value: 13000 },
    { day: "30th Jul", value: 14000 },
    { day: "31st Jul", value: 14000 },
  ],
  topPerformingAgentsData: [
    { number: "$38,250", description: "Alex Ramirez", image: "agent" },
    { number: "$37,800", description: "Emily Carter", image: "agent" },
    { number: "$36,550", description: "Michael Johnson", image: "agent" },
  ],
};
